const Quote = () => (
  <div className="quote-page">
    <blockquote>
      <q className="quote-description">
        Mathematics is not about numbers, equations, computations, or algorithms:
        it is about understanding.
      </q>
      <p className="quote-author">
        &mdash;William Paul Thurston
      </p>
    </blockquote>
  </div>
);

export default Quote;
